import React from "react";
import HeaderSection from "./MoreDictionaries/HeaderSection";
import BackedBySection from "./MoreDictionaries/BackedBySection";
import FeaturesBanners from "./FeaturesPage/FeaturesBanners";
import MoreFeaturesSection from "./MoreDictionaries/MoreFeaturesSection";

const MoreDictionariesPage = () => {
  return (
    <>
      <HeaderSection />
      <BackedBySection />
      <FeaturesBanners
        sections={[
          "Wide Areas of Expertise",
          "Advanced Search Tools",
          "Learning Features",
        ]}
      />
      <MoreFeaturesSection />
    </>
  )
}

export default MoreDictionariesPage